
import { Routes } from '@angular/router';
import { AfterLoginService } from './core/service/auth/after-login.service';

export const AppRoutes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login'
    },
    {
        path: 'login',
        loadChildren: './modules/login/login.module#LoginModule'
    },
    {
        path: 'activate',
        loadChildren: './modules/activate/activate.module#ActivateModule'
    },
    {
        path: 'recovery',
        loadChildren: './modules/recovery/recovery.module#RecoveryModule'
    },
    {
        path: 'register',
        loadChildren: './modules/register/register.module#RegisterModule'
    },
    {
        path: 'logout',
        loadChildren: './modules/logout/logout.module#LogoutModule'
    },
    {
        path: 'project',
        canActivate: [AfterLoginService],
        loadChildren: './modules/admin/admin.module#AdminModule'
    },
]
